import { BillingReportRequest } from '@core/domain/model/billing-report/billing-report-request.model';
import { MyInvoicesListingItem } from '@core/domain/model/invoices/my-invoices-listing.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { BillingReportListFilter } from '@pages/my-invoices/billing-report/billing-report-listing/model/billing-report-list.model';
import { MyInvoicesFilterFormModel } from '@pages/my-invoices/my-invoices-listing/model/my-invoices-filter-form.model';
import { PaginatorInput } from '@shared/components/paginator/models/paginator-input.model';
import { SortEvent } from '@shared/components/table/sort/model/sort.model';

export const myInvoicesActions = createActionGroup({
  source: 'MyInvoices',
  events: {
    fetchListingData: emptyProps,
    setListingData: props<{ data: Array<MyInvoicesListingItem> }>(),
    setListingDataError: props<{ error: string }>(),
    setListingDataFilters: props<{ filters: MyInvoicesFilterFormModel | PaginatorInput | SortEvent }>(),
    fetchRequestList: emptyProps(),
    setRequestList: props<{ data: BillingReportRequest[] }>(),
    sortRequestList: props<{ sort: SortEvent }>(),
    pageRequestList: props<{ page: PaginatorInput }>(),
    filterRequestList: props<{
      filter: BillingReportListFilter;
    }>(),
    setRequestListError: props<{ error: string }>(),
  },
});
